import React, {useEffect} from "react";
import AOS from 'aos';
import 'aos/dist/aos.css';
import styles from './styles/getStarted.module.css'
import googleplayicon from "../../../assets/images/google-play.png"; 
import appleicon from "../../../assets/images/apple_icon.png";
import backgroundPattern from "../../../assets/images/getstartedbg.png";
import { Link } from "react-router-dom";

const GetStarted: React.FC = () => {

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out', 
      once: true,
    });
  }, []);

  return (
    <section
      className="w-full mt-8 sm:mt-32 sm:min-h-screen flex flex-col items-center justify-center text-center relative"
      style={{
        backgroundImage: `url(${backgroundPattern})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center", 
        backgroundSize: "cover",
      }}
    >
      <div data-aos="fade-up" data-aos-delay="100" className="w-full max-w-screen-xl px-6 py-16 lg:py-24">
        <h2 className="text-4xl sm:text-4xl md:text-7xl font-semibold text-black mb-4">
          Get started
        </h2>
        <p data-aos="fade-up" data-aos-delay="200" className="text-sm md:text-2xl sm:text-base text-gray-600 max-w-2xl mx-auto mb-8">
          Start with Beats Fussion today and become a shining light as a viewer or
          dancer in the next dance revolution.
        </p>

        {/* Buttons */}
        <div className="mt-8 flex justify-center flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
          <Link to="https://play.google.com/store/apps/details?id=com.techwings.beatsfussion" target="_blank"
            className="px-8 sm:px-10 py-5 sm:py-3 text-white rounded-lg flex items-center justify-center space-x-2 hover:bg-purple-900"
            style={{ backgroundColor: '#fa18e2' }}
            data-aos="fade-up" 
            data-aos-delay="300"
          >
            <img src={googleplayicon} alt="Google Play" className={`w-5 h-5 sm:w-6 sm:h-6 ${styles.adjustPlayIcon}`} />
            <span className={`text-sm sm:text-base text-left font-medium ${styles.adjustPlayText}`}>
              Get it on <br className={styles.hideBreak} /> <span className="text-lg">Google Play</span>
            </span>
          </Link>
          <button data-aos="fade-up" 
            data-aos-delay="400" className="px-6 sm:px-8 py-5 sm:py-3 bg-purple-800 text-white rounded-lg flex items-center justify-center space-x-2 hover:bg-purple-900">
            <img src={appleicon} alt="App Store" className="w-8 h-8 sm:w-10 sm:h-10" />
            <span className="text-sm sm:text-base text-left font-medium">
              Download on the <br className={styles.hideBreak} /> <span className="text-lg">App Store</span>
            </span>
          </button>
        </div>
      </div>
    </section>
  );
};

export default GetStarted;
